/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_DividerInputs */

const cs_builder_block_divider = /** @type {(inputs: Builder_Block_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oddělovač`)
};

const en_builder_block_divider = /** @type {(inputs: Builder_Block_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divider`)
};

/**
* | output |
* | --- |
* | "Divider" |
*
* @param {Builder_Block_DividerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_divider = /** @type {((inputs?: Builder_Block_DividerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_DividerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_divider(inputs)
	return cs_builder_block_divider(inputs)
});